import React from 'react';
import { useNavigate } from 'react-router';

const useFirstShipment = () => {
  const [openModals, setOpenModals] = React.useState({
    completeData: false,
    recharge: false,
  });
  const navigate = useNavigate();

  const recharge = () => {
    setOpenModals({ completeData: false, recharge: true });
  };

  const completeData = () => {
    setOpenModals({ completeData: true, recharge: false });
  };

  const closeModals = () => {
    setOpenModals({ completeData: false, recharge: false });
  };

  const verifyCoverage = () => {
    navigate('/coverage');
  };

  const sendShipment = () => {
    navigate('/');
  };

  return {
    openModals,
    recharge,
    completeData,
    verifyCoverage,
    sendShipment,
    closeModals,
  };
};

export default useFirstShipment;
